'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../../stores/CartStore.jsx');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Actions = require('../../../Actions.jsx');

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require('../../../utils/Utility.jsx');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UtensilsAndNapkinsView = function (_React$Component) {
    _inherits(UtensilsAndNapkinsView, _React$Component);

    function UtensilsAndNapkinsView(props) {
        _classCallCheck(this, UtensilsAndNapkinsView);

        var _this = _possibleConstructorReturn(this, (UtensilsAndNapkinsView.__proto__ || Object.getPrototypeOf(UtensilsAndNapkinsView)).call(this, props));

        _this.clickedUtensilsAndNapkins = function (e) {
            var value = e.target.value;

            _this.setState({
                isUtensilsAndNapkins: value
            });

            _Actions2.default.addIsUtensilsAndNapkinsEnabled(value);
        };

        _this.state = {
            isUtensilsAndNapkins: ''
        };
        return _this;
    }

    _createClass(UtensilsAndNapkinsView, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            this.setState({
                isUtensilsAndNapkins: _CartStore2.default.getIsUtensilsAndNapkinsEnabled()
            });
        }

        // UNSAFE_componentWillReceiveProps(nextProps) {
        //     if(nextProps.isActive != this.props.isActive) {
        //         this.setState({
        //             orderType   : "CurbsidePickup"
        //         },() => {
        //             Actions
        //                 .addDeliveryAddress
        //             (this.state.orderType, null, -1);
        //         });
        //     }
        // }

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}

        /*
        * Call onclick function on the radio button
        * */

    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'border-bottom pb-2 mb-3', id: "utensils-section" },
                _react2.default.createElement(
                    'div',
                    { className: 'input-group curbside-div' },
                    _react2.default.createElement(
                        'div',
                        { className: ' radio-div' },
                        _react2.default.createElement(
                            'h6',
                            { className: "cart-heading f16-default mb-0" },
                            'Include Utensils and Napkins?'
                        ),
                        _react2.default.createElement('span', { className: 'clearfix' }),
                        _react2.default.createElement(
                            'label',
                            { className: 'container-radio display-box cart-header' },
                            'Yes',
                            _react2.default.createElement('input', { type: 'radio', name: 'utensilsAndNapkins', id: 'yes', value: 'true',
                                onChange: this.clickedUtensilsAndNapkins,
                                checked: this.state.isUtensilsAndNapkins == 'true',
                                tabIndex: 12
                            }),
                            _react2.default.createElement('span', { className: 'checkmark-radio' })
                        ),
                        _react2.default.createElement(
                            'label',
                            { className: 'container-radio display-box m-l-20 cart-header' },
                            'No',
                            _react2.default.createElement('input', { type: 'radio', name: 'utensilsAndNapkins', id: 'no', value: 'false',
                                onChange: this.clickedUtensilsAndNapkins,
                                checked: this.state.isUtensilsAndNapkins == 'false',
                                tabIndex: 13
                            }),
                            _react2.default.createElement('span', { className: 'checkmark-radio' })
                        )
                    )
                )
            );
        }
    }]);

    return UtensilsAndNapkinsView;
}(_react2.default.Component);

exports.default = UtensilsAndNapkinsView;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/UtensilsAndNapkinsView.jsx
// module id = 716
// module chunks = 0